export default {
  // Hero
  aboutHeroTag: "À Propos d'AIP",
  aboutHeroTitle1: "Partenaire de Confiance pour",
  aboutHeroTitle2: "les Affaires en Afrique de l'Est",
  aboutHeroDesc: "Africa Investment Portal (AIP) est une firme de facilitation des affaires de premier plan basée à Kigali, au Rwanda, spécialisée dans l'entrée sur le marché, la conformité réglementaire et la facilitation de l'investissement en Afrique de l'Est.",

  // Story
  storyTag: "Notre Histoire",
  storyTitle: "Simplifier les Affaires",
  storyTitleAccent: "en Afrique de l'Est",
  storyP1: "Africa Investment Portal a été fondé avec une mission claire : lever les barrières pour les entreprises et investisseurs internationaux entrant sur les marchés en rapide croissance de l'Afrique de l'Est. Nous avons compris que naviguer dans des environnements réglementaires complexes, des systèmes juridiques divers et des nuances culturelles était un défi majeur pour les entités étrangères.",
  storyP2: "Aujourd'hui, AIP est devenu le partenaire privilégié des entreprises cherchant une entrée sur le marché sans faille, une conformité réglementaire et une croissance commerciale durable au Rwanda, au Kenya, en Ouganda, en Tanzanie, en Éthiopie, au Burundi et en RDC. Notre équipe d'experts locaux, de spécialistes réglementaires et de conseillers en investissement travaille main dans la main avec les clients pour obtenir des résultats.",
  storyHQLabel: "Siège Social à",
  storyHQCity: "Kigali, Rwanda",
  storyStatFounded: "Fondé",
  storyStatCountries: "Pays",
  storyStatClients: "Clients Servis",

  // Mission & Vision
  missionVisionTag: "Nos Valeurs",
  missionTitle: "Notre Mission",
  missionDesc: "Donner aux entreprises et aux investisseurs les moyens d'entrer, d'opérer et de croître avec succès en Afrique de l'Est en fournissant une facilitation experte, une orientation réglementaire et un support d'accès stratégique au marché — rendant l'opportunité de l'Afrique de l'Est accessible à tous.",
  visionTitle: "Notre Vision",
  visionDesc: "Être la plateforme de facilitation de l'investissement et des affaires la plus fiable en Afrique de l'Est — le pont qui relie l'ambition mondiale à l'opportunité africaine, stimulant une croissance économique durable dans toute la région.",
  valuesTitle: "Ce qui Nous Anime",
  valueIntegrityTitle: "Intégrité",
  valueIntegrityDesc: "Nous maintenons les normes éthiques les plus élevées dans chaque engagement, assurant transparence et responsabilité.",
  valueExcellenceTitle: "Excellence",
  valueExcellenceDesc: "Nous fournissons une qualité exceptionnelle dans tous nos services, relevant continuellement la barre pour nos clients.",
  valuePartnershipTitle: "Partenariat",
  valuePartnershipDesc: "Nous construisons des relations durables, considérant le succès de chaque client comme notre propre mission.",
  valueEfficiencyTitle: "Efficacité",
  valueEfficiencyDesc: "Nous agissons vite et résolvons les problèmes, garantissant aux entreprises des résultats sans délais inutiles.",

  // Team
  teamTag: "Direction",
  teamTitle: "Rencontrez Notre Équipe",
  teamDesc: "Une équipe dévouée de spécialistes de l'Afrique de l'Est, d'experts réglementaires et de conseillers en investissement travaillant pour votre succès.",

  // CTA
  aboutCtaTag: "Prêt à Commencer?",
  aboutCtaTitle: "Construisons Votre Entreprise",
  aboutCtaAccent: "en Afrique de l'Est Ensemble",
  aboutCtaExplore: "Explorer les Services",
  aboutCtaContact: "Contactez-nous",
};